// @ts-check
import React from 'react'
import { ThemedIcon } from '..'
import styles from './style.css'
import cn from 'classnames'

/**
 * @param {{
 * type: Kind,
 * title: string | React.ReactChild,
 * children: React.ReactChild | React.ReactChild[]
 * className?: string | undefined
 * }} props
 */
const Message = ({ title, children, type: kind, className }) => (
  <article className={cn(styles.message, className)}>
    <h1 className={styles.header}>
      <ThemedIcon kind={kind} />
      {title}
    </h1>
    {children ? <div className={styles.text}>{children}</div> : null}
  </article>
)

Message.defaultProps = {
  type: 'mail'
}

export { Message }
